import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import useSWR from 'swr/immutable'

import type { AppInfo as CapacitorAppInfo } from '@capacitor/app'

const webFallbackInfo: CapacitorAppInfo = {
  name: 'MijnZiekenhuis',
  id: 'web',
  version: '',
  build: '',
}

function getAppInfo() {
  return Capacitor.isNativePlatform() ? App.getInfo() : webFallbackInfo
}

export function useAppInfo(): CapacitorAppInfo | undefined {
  return useSWR('appInfo', getAppInfo).data
}
